import { ButtonType, EpicIcons, TooltipPosition } from "@constellation-academy/epic-ui";
import { useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import type { deleteDiscountActionButton_DeleteDiscountActionMutation } from "@relay/deleteDiscountActionButton_DeleteDiscountActionMutation.graphql";
import { DELETE_DISCOUNT_ACTION_MUTATION } from "./delete-discount-action-button.graphql";
import type { DeleteDiscountActionButtonProps } from "./delete-discount-action-button.types";
import { Button, ButtonVariant } from "../../../../components/button";

export const DeleteDiscountActionButton = ({ id }: DeleteDiscountActionButtonProps) => {
	const { t } = useTranslation("common");
	const [deleteDiscountAction, isLoading] =
		useMutation<deleteDiscountActionButton_DeleteDiscountActionMutation>(
			DELETE_DISCOUNT_ACTION_MUTATION,
		);

	const handleDeleteDiscountActionOnClick = () => {
		deleteDiscountAction({
			variables: {
				input: {
					discountActionId: id,
				},
			},
		});
	};

	return (
		<Button
			type={ButtonType.Button}
			variant={ButtonVariant.Error}
			icon={EpicIcons.TRASH}
			tooltip={t("discounts.deleteDiscount")}
			position={TooltipPosition.Left}
			loading={isLoading}
			disabled={isLoading}
			onClick={handleDeleteDiscountActionOnClick}
		/>
	);
};
